import { render } from "./FavForm.vue?vue&type=template&id=5a0f569b&scoped=true"
import script from "./FavForm.vue?vue&type=script&lang=js"
export * from "./FavForm.vue?vue&type=script&lang=js"

import "./FavForm.vue?vue&type=style&index=0&id=5a0f569b&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/www/releases/20260911022759/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a0f569b"]])

export default __exports__